import React from 'react';
import { connect } from 'react-redux';
import { UI } from '@leverege/ui-redux';
import { ValuesCache } from '@leverege/value-cache';
import { GroupDelegate } from '@leverege/molten-core';
// import { DataSources } from '@leverege/ui-attributes'

// import Relationship from '../Relationship'
// import GroupingsUtil from '../groupings/GroupingsUtil'
// import FilterSourcesModel from '../../filters/FilterSourcesModel'
import { jsx as _jsx } from "react/jsx-runtime";
class GroupingLoadDataRenderer extends React.Component {
  constructor(props) {
    super(props);
    this.cache = new ValuesCache();
    this.state = {
      mode: 'passThrough'
    };
  }

  // componentDidMount() {
  //   this.loadData()
  // }

  // componentWillUnmount() {
  //   this.unmounted = false
  //   clearTimeout( this.timer )
  // }

  // componentDidUpdate( prevProps ) {
  //   const { sectionsState : pSectionsState, filters : pFilters } = prevProps
  //   const { sectionsState, filters } = this.props
  //   if ( filters !== pFilters || sectionsState !== pSectionsState ) {
  //     this.loadData()
  //   }
  // }

  //   loadData = async () => {
  //     // Incase of filter change, restart the timer
  //     clearTimeout( this.timer ) 
  //     if ( !this.unmounted ) { 
  //       try {
  //         // this.doLoadData()
  //       } finally {
  //         if ( this.unmounted !== true ) {
  //           this.timer = setTimeout( this.loadData, 30000 )
  //         }
  //       }
  //     }
  //   }

  // async doLoadData() {
  //   const {
  //     dispatch,
  //     relationship : { isItem },
  //     delegate : pActions
  //   } = this.props
  //   const { objRef, delegate } = this.getTileGroupDelegateAndObjRef()
  //   if ( ( !objRef && !delegate ) || isItem ) {
  //     this.setState( { mode : 'passThrough' } )
  //   } else {
  //     let item = objRef && DataSources.getData( objRef )

  //     if ( item == null && delegate ) {
  //       item = await dispatch( delegate.get() )
  //       if ( this.unmounted ) { return }
  //     }

  //     if ( item?.metadata?.groupings ) {
  //       const filter = this.getFilter( item, delegate )

  //       if ( filter == null ) {
  //         this.setState( { mode : 'passThrough' } )
  //         return
  //       }

  //       try {
  //         await dispatch( pActions.search( { filter } ) )

  //         if ( this.unmounted ) {
  //           return
  //         }
  //         this.setState( { mode : 'query' } )
  //       } catch ( err ) {
  //         this.setState( { mode : 'passThrough' } )
  //       }
  //     } else {
  //       this.setState( { mode : 'passThrough' } )
  //     }
  //   }
  // }

  // getFilter( groupingItem, delegate ) {
  //   const { sectionsState, relationship : { blueprint : { type } }, filters } = this.props
  //   const sections = groupingItem.metadata.groupings.sections
  //   const selectedSections = sectionsState[delegate.id] || {}

  //   const attrConditions = {}

  //   Object
  //     .entries( selectedSections )
  //     .forEach( ( [ key, value ] ) => {
  //       const sectionData = sections.find( section => section.id === key )
  //       if ( sectionData ) {
  //         const attrName = sectionData.attributeName
  //         const attribute = Attributes.getAttribute( attrName, type )
  //         const selectedValue = sectionData.values.find( v => v.id === value )
  //         const val = selectedValue.value

  //         if ( attribute && attribute.blueprint?.field ) {
  //           if ( !attrConditions[attrName] ) {
  //             attrConditions[attrName] = []
  //           }
  //           const field = attribute.blueprint.field
  //           let condition

  //           if ( val ) {
  //             const fieldType = attribute.blueprint.attribute?.searchType || 'string'
  //             condition = { type : 'equals', field, fieldType, empty : false, value : val }
  //           } else {
  //             condition = { type : 'exists', field, not : true }
  //           }

  //           attrConditions[attrName].push( condition )
  //         }
  //       }
  //     } )

  //   if ( Object.keys( attrConditions ).length === 0 ) {
  //     return null
  //   }

  //   const f = { 
  //     type : 'logical', 
  //     operator : 'and', 
  //     conditions : Object.values( attrConditions ).map( ( value ) => {
  //       return { type : 'logical', operator : 'or', conditions : value }
  //     } )
  //   }

  //   const parentFilters = FilterSourcesModel.getFilter( filters )

  //   if ( parentFilters ) {
  //     f.conditions.push( parentFilters )
  //   }

  //   return f
  // }

  getItems() {
    const {
      mode
    } = this.state;
    const {
      items,
      filteredItems
    } = this.props;
    if (mode === 'passThrough') {
      return items;
    }
    return this.cache.calc('dataItems', this.createDataItems, filteredItems);
  }
  createDataItems = results => {
    const {
      relationship,
      delegate,
      childPath
    } = this.props;
    const {
      childRef
    } = this.state;
    // const { page, perPage } = this.getQueryOptions()
    const page = 0;
    const perPage = results?.limit || 100;
    const type = relationship.blueprint.type;
    const ref = childPath ? childRef : delegate.getInterfaceUrl();
    const {
      items
    } = results || {};
    return {
      status: results?.status || null,
      loading: results?.status === 'api.interface.status.loading',
      perPage,
      page,
      count: results?.total || 0,
      items: items == null ? [] : items.map(device => {
        if (device == null) {
          return device;
        }
        return {
          type,
          ref,
          id: device.id,
          data: device
        };
      })
    };
  };

  // getTileGroupDelegateAndObjRef( ) {
  //   const { match } = this.props
  //   const tgRel = this.getTileGroupRelationship()
  //   if ( tgRel == null ) {
  //     return {}
  //   }
  //   return this.cache.calc( 'item', Relationship.getObjectRefAndAction, tgRel, match )
  // }

  // getTileGroupRelationship( ) {
  //   const { relationship } = this.props
  //   return this.cache.calc( 'rel', GroupingsUtil.findRelationship, relationship )
  // }

  render() {
    const {
      renderer: Renderer,
      ...rest
    } = this.props;
    const items = this.getItems();
    return Renderer ? /*#__PURE__*/_jsx(Renderer, {
      ...rest,
      items: items
    }) : null;
  }
}
const EMPTY = {};
export default connect((state, props) => {
  const {
    delegate: pActions
  } = props;
  const delegate = new GroupDelegate({
    relationship: pActions.relationship,
    match: pActions.match,
    queryName: 'groupingLoadData'
  });
  return {
    sectionsState: UI.get(state, 'itemSections') || EMPTY,
    filteredItems: delegate.getList(state, {
      getAll: true
    }),
    delegate
  };
})(GroupingLoadDataRenderer);